import { Segment } from '../services/analytics-services/segment';

export const trackWalletInsureAll = (walletId, isUpdate, InsureAllValue) => {
  Segment.trackEvent('WALLET_REGISTRATION_INSURE_ALL', {
    walletId,
    isUpdate,
    InsureAllValue,
  });
};
